import uniio from '../../utils/uni.socket.io'
import store from '../index.js'
import Vue from 'vue'
const socketUrl = 'https://aimachefu.aimatech.com';

let heartTimer = null;
let reporTimerArr = [];
let orderTypeObj = {
	qiang: 1,
	closeQiang: 2,
}
export const state = {
	socketTask: null,
	websocketData: {}, // 存放从后端接收到的websocket数据,
	orderMesType: ''
};
export const mutations = {
	setWebsocketData(state, data) {
		state.websocketData = data
	}
};
let tokens = ''
export const actions = {
	websocketInit({ state, dispatch }, token) {
		//console.log(token);
		tokens = token
		state.socketTast = uniio.connect(socketUrl, {
			path: '/ws/socket.io',
			transports: ['websocket']
		});
		// console.log(state.socketTast )
		state.socketTast.on('connect', function() {
			// console.log("连接成功发送数据");
			state.socketTast.emit('bind_sc', {
				userAccessToken: token
			})
			dispatch('websocketStartHeart', ); // 开始发送心跳
		});

		// 接收心跳数据
		state.socketTast.on('heartCallBack', function(res) {
			// console.warn(res)
		});

		// 接收订单数据
		state.socketTast.on('ordersMsg', function(res) {
			// console.log('收到订单数据：' + JSON.stringify(res));
			// dispatch('websocketOnMessage', res);
			store.commit('changeOrderType')
		});

		state.socketTast.on('disconnect', function() {
			console.warn("与服务其断开");
			clearHeart();
		});
		state.socketTast.on('reconnecting', function() {
			console.warn("重连");
			// clearHeart();
		});
		//监听断线重连
		state.socketTast.on('reconnect', function(res) {
			console.warn("重连成功" + res);
			// state.socketTast.emit('bind_sc', {
			// 	userAccessToken: token
			// })
			// state.socketTast.disconnect();
			// state.websocketData={}
			// clearHeart();
			// store.dispatch('websocketInit',tokens)
			Vue.prototype.$bus.$emit('againSoket')
		});
		//链接成功
		state.socketTast.on('callback', function() {

			state.socketTast.emit('heart_sc')
		});
		//排队数量变更
		state.socketTast.on('getDotNum', function() {
			// console.warn("排队数量变更");
			// store.dispatch('getOrderAgainNum')
		});
		//大屏订单状态改变
		state.socketTast.on('StoreMsg', function() {
			// console.log('大屏状态改变')
			// console.warn("排队数量变更");
			store.commit('changeOrderType')
			// Vue.prototype.$bus.$emit('changeList')

		});
		state.socketTast.on('closeStore', function(res) {
			store.commit('changeBoxShow')
			dispatch('websocketClose')
		});
	},

	// 接收到订单推送数据
	/**
	 * @param {type} //qiang 你有一条新的待抢单   closeQiang  订单被抢或取消  catchOrder 派单通知
	 */
	websocketOnMessage({ commit }, res) {
		let { type, oid } = res;

	},
	// 发送心跳
	websocketStartHeart({ state, commit }, res) {
		clearHeart();
		heartTimer = setInterval(function() {
			state.socketTast.emit('heart_sc')
		}, 20000)
		reporTimerArr.push(heartTimer);
	},
	// 关闭连接
	websocketClose({ state }) {
		if (!state.socketTast) return
		// console.warn('关闭socket连接');
		state.socketTast.disconnect();
		clearHeart();
	}
};

function clearHeart() {
	// console.log('清除定时器');

	reporTimerArr.forEach(item => {
		clearInterval(item);
	})
	heartTimer = null;
}

function formatNewOrder(type, oid) { // 处理订单消息

}

function judjeIsLook(type) { // 判断是否有未读工单

}